const useAmexBCE = () => {
  const isAmexUser = document
    .getElementById('hc-sign-up-funnel-react-app')
    ?.getAttribute('data-amexbce');

  if (isAmexUser) return true;

  return false;
};

export default useAmexBCE;
